import React from "react";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import SwitchList from "../../../../../../ui/SwitchList";
import CriterionTable from "./CriterionTable";

const ratingSystem = [
  {
    id: 1,
    label:
      "двухбалльная («удовлетворительно» («зачтено»), «неудовлетворительно» («не зачтено»))"
  },
  {
    id: 2,
    label:
      "четырехбалльная («отлично», «хорошо», «удовлетворительно», «неудовлетворительно»)"
  }
];

const estimateType = [
  {
    type: 1,
    description: "Двубальная"
  },
  {
    type: 2,
    description: "Четырехбальная"
  }
];

const doubleEstimate = [
  {
    id: 2,
    description: "Не зачтено"
  },
  {
    id: 3,
    description: "Зачтено"
  }
];

const quadEstimate = [
  {
    id: 2,
    description: "Неудовлетворительно"
  },
  {
    id: 3,
    description: "Удовлетворительно"
  },
  {
    id: 4,
    description: "Хорошо"
  },
  {
    id: 5,
    description: "Отлично"
  }
];

const QualityСontrol = ({ moduleEstimate, change }) => {
  // console.log(moduleEstimate);
  return (
    <div>
      <Box fontSize={14} mb={2}>
        Оценка качества освоения модуля
      </Box>
      <TextField
        label="Информация об оценивании"
        multiline
        rows={8}
        required
        fullWidth
        value={
          (moduleEstimate &&
            moduleEstimate.data &&
            moduleEstimate.data.description) ||
          ""
        }
        InputLabelProps={{
          shrink: true
        }}
        onChange={e => change("description", e.target.value)}
      />
      <Box fontSize={14} mt={4}>
        Система оценки
      </Box>

      <SwitchList
        items={ratingSystem}
        labelPlacement="end"
        value={
          (moduleEstimate && moduleEstimate.data && moduleEstimate.data.type) ||
          null
        }
        change={e => change("type", parseInt(e.target.value, 10))}
      />
      <Box fontSize={14} mt={4}>
        Критерии оценки
      </Box>
      <CriterionTable />
    </div>
  );
};
const mapStateToProps = state => ({
  moduleEstimate: state.modules.moduleEstimate
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(QualityСontrol);
